import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {gameUiTexts} from 'data/ui-texts';
import apiHelper from 'helpers/api-helper';
import Button from 'components/ui/button/button';
import Popup from 'components/ui/popup/popup';
import './brainstorm-simple-group.scss';

const BrainstormSimpleGroup = ({partIndex, minigameData, gameId, minigameGameData, handleGoToNextPart}) => {

	const [isLoading, setIsLoading] = useState(false);
	const [showIntroPopup, setShowIntroPopup] = useState(true);
	const [showInfoPopup, setShowInfoPopup] = useState(false);
	const [textInput, setTextInput] = useState('');


	/**
	 * Handle input
	 * @param {obj} event 
	 */
	const handleInput = (event) => {
		let value = event.target.value;
		setTextInput(value);
	};

	/**
	 * Submit input
	 * @param {string} categoryId 
	 * @returns 
	 */
	const submitInput = (categoryId) => {
		if (!textInput || textInput.length === 0 || isLoading) return; 

		setIsLoading(true);
		apiHelper('group/submit-minigame-input', {
			gameId: gameId,
			partId: partIndex,
			minigameType: minigameData.parts[partIndex].type,
			minigameId: minigameData.id,
			value: textInput
		}).then(
			(response)=>{
				if (response.status === 'success') {
					setTextInput('');
				} else {
					console.error(response);
				}
				setIsLoading(false);
			},
			(error) => {
				console.error(error);
				setIsLoading(false);
			}
		);
	};

	return (
		<div className="BrainstormSimpleGroup">

			{/* Part 1 */}
			<div className="BrainstormSimpleGroup-part1">
				{/* <div className="BrainstormSimpleGroup-instructions"></div> */}
				<textarea 
					className="BrainstormSimpleGroup-textarea"
					placeholder={minigameData.parts[partIndex].placeholder}
					value={textInput ? textInput : ''}
					onChange={(event)=>{handleInput(event);}}
					
				/>
				<div className="BrainstormSimpleGroup-submitBtn">
					<Button 
						isLoading={isLoading}
						classes={['red', 'uppercase']}
						text={minigameData.parts[partIndex].submitButton} 
						onClick={() => {submitInput();}} 
					/>
				</div>						
			</div>


			

			{/* Info popup button */}
			{minigameData.parts[partIndex].part1InfoPopupText &&
				<div className="BrainstormSimpleGroup-infoBtn">
					<Button classes={['info']} onClick={() => {setShowInfoPopup(true);}} />
				</div>
			}

			{/* Info popup */}
			{showInfoPopup &&
				<Popup
					type={'intro-medium'}
					text={minigameData.parts[partIndex].part1InfoPopupText} 
					buttons={[
						{text: gameUiTexts.ok, action: setShowInfoPopup, parameters: [false]}
					]}
				/>
			}

			{/* Intro popup */}
			{showIntroPopup && 
				<Popup 
					type={'intro'}
					text={minigameData.parts[partIndex].part1IntroPopupText} 
					buttons={[
						{text: gameUiTexts.ok, action: setShowIntroPopup, parameters: [false]}
					]}
				/>
			}
		</div>
	);
};

BrainstormSimpleGroup.propTypes = {
	partIndex: PropTypes.number.isRequired,
	minigameData: PropTypes.object.isRequired,
	gameId: PropTypes.string.isRequired,
	minigameGameData: PropTypes.object,
	handleGoToNextPart: PropTypes.func.isRequired
};

export default BrainstormSimpleGroup;
